import {
  RAW_DATA_VIDEO_PLAYER_OPEN_MODAL,
  RAW_DATA_VIDEO_PLAYER_CLOSE_MODAL,
  RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_REQUEST,
  RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_ERROR,
  CLEAR_REDUX
} from "Redux/actionTypes";

const INIT_STATE = {
  openModal: false,
  urls: [],
  currentVideoIndex: 0,
  title: null,
  loading: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case RAW_DATA_VIDEO_PLAYER_OPEN_MODAL:
      return {
        ...state,
        openModal: true,
        urls: Array.isArray(action.payload.urls) ? action.payload.urls : [action.payload.urls],
        currentVideoIndex: 0,
        title: action.payload.title,
        loading: false
      };

    case RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_REQUEST:
      return {
        ...state,
        loading: true
      };

    case RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_ERROR:
      return {
        ...state,
        loading: false
      };

    case RAW_DATA_VIDEO_PLAYER_CLOSE_MODAL:
      return {
        ...state,
        openModal: false,
        urls: [],
        currentVideoIndex: 0,
        title: null,
        loading: false
      };

    case CLEAR_REDUX:
      return ["", "RAW_DATA_VIDEO_PLAYER"].includes(action.payload.option)
        ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
        : { ...state }

    default:
      return state;
  }
};
